import React from "react";
import Helmet from "react-helmet";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Image,
  List,
  Segment,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import ss_logo from "./assets/logo.png";

const ArticleLayout = ({
  title,
  description,
  url,
  heading,
  lead,
  relatedLinks,
  children,
}) => (
  <div>
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={`https://skolkoskinut.ru${url}`} />
      <link rel="canonical" href={`https://skolkoskinut.ru${url}`} />
    </Helmet>

    <Container textAlign="center" style={{ padding: "20px 0" }}>
      <Image
        src={ss_logo}
        size="medium"
        centered
        as={Link}
        to="/"
        className="clickable"
        alt="СколькоСкинуть логотип"
      />
      <Header as="h1" style={{ marginTop: "10px" }}>
        {heading}
      </Header>
      {lead && <Header.Subheader>{lead}</Header.Subheader>}
    </Container>

    <Container style={{ padding: "20px 0 40px 0" }}>
      <Segment padded="very" raised>
        {children}

        <Divider />
        <Button as={Link} to="/" color="orange" fluid size="large">
          Перейти к калькулятору
        </Button>

        {relatedLinks && relatedLinks.length ? (
          <>
            <Divider horizontal>Полезно рядом</Divider>
            <List bulleted>
              {relatedLinks.map(({ to, text }) => (
                <List.Item key={to}>
                  <Link to={to}>{text}</Link>
                </List.Item>
              ))}
            </List>
          </>
        ) : null}
      </Segment>
    </Container>
  </div>
);

export const MainIntentArticle = () => (
  <ArticleLayout
    title="Калькулятор: кто кому сколько должен | СколькоСкинуть"
    description="Онлайн-калькулятор «СколькоСкинуть» считает, кому сколько переводить, и сокращает число переводов до минимума."
    url="/kto-komu-skolko-dolzhen"
    heading="Кто кому сколько должен и сколько переводить"
    lead="Калькулятор делит расходы между людьми, сокращает количество переводов до минимума и показывает готовый список переводов."
    relatedLinks={[
      { to: "/razdelit-summu-na-chelovek", text: "Разделить сумму на человек" },
      {
        to: "/posle-vecherinki-kto-skolko-skinulsya",
        text: "Подсчет после вечеринки",
      },
    ]}
  >
    <Header as="h2">Как работает калькулятор "кто сколько должен"</Header>
    <p>
      Сервис собирает все траты, кто платил в каких долях в каждой покупке кто участвует,
      после чего выдает список переводов: кто кому должен отправить деньги. Это решает проблемы, когда нужен калькулятор "кто
      сколько должен скинуть денег" когда надо рассчитать сколько скидываться онлайн.
    </p>
    <List ordered>
      <List.Item>Добавьте участников: друзей, коллег или родственников.</List.Item>
      <List.Item>Запишите покупки и укажите, кто за них заплатил.</List.Item>
      <List.Item>
        Можно указать доли: поровну по умолчанию или в своих пропорциях (например,
        2:1:1).
      </List.Item>
      <List.Item>Нажмите "Рассчитать" и получите готовые переводы.</List.Item>
    </List>

    <Image
      src="/ss-example.png"
      alt="Пример расчета: таблица покупок и итоговые переводы"
      fluid
      rounded
      style={{ margin: "20px 0" }}
    />

    <Header as="h2">Минимум переводов — главный бонус</Header>
    <p>
      Встроенный алгоритм оптимизирует цепочку расчетов: он сводит переводы к
      минимальному количеству, чтобы не гонять деньги по кругу. В итоге каждый
      отправляет 1–2 платежа, а не каждый раз скидывается за каждую покупку.
    </p>

    <Header as="h2">Зачем это нужно</Header>
    <Grid stackable columns={2}>
      <Grid.Column>
        <List bulleted>
          <List.Item>
            Быстрое согласование без сложной делёжки: кто кому сколько переводит видно сразу.
          </List.Item>
          <List.Item>
            Никаких таблиц вручную — калькулятор сам считает и сортирует платежи.
          </List.Item>
          <List.Item>
            Можно делиться ссылкой, чтобы все видели общий итог и сами могли вносить траты.
          </List.Item>
        </List>
      </Grid.Column>
      <Grid.Column>
        <Segment secondary>
          <Header as="h4">Пример</Header>
          <p>
            Трое друзей заказали доставку. Анна оплатила 2300 ₽, Дима — 1200 ₽,
            Катя ничего не платила. Каждому нужно скинуться поровну. Сервис
            покажет: Катя скидывает Ане 1334₽, а Диме — 33₽. Это самый простой пример.
          </p>
        </Segment>
      </Grid.Column>
    </Grid>

    <Header as="h2">Частые запросы, которые мы закрываем</Header>
    <List bulleted>
      <List.Item>«Кто кому сколько должен после нескольких трат»</List.Item>
      <List.Item>«Посчитать, скок скинуть каждому прямо онлайн»</List.Item>
      <List.Item>«Калькулятор кто сколько должен скинуть денег в компании»</List.Item>
      <List.Item>«Сколько переводить, если платили по очереди»</List.Item>
    </List>

    <Header as="h2">Попробуйте сейчас. Это полностью бесплатно.</Header>
    <p>
      Откройте калькулятор, добавьте участников и траты — расчеты обновляются
      сразу. Ссылкой можно поделиться в мессенджерах, чтобы все видели результат
      и перевели нужные суммы без лишних вопросов.
    </p>
  </ArticleLayout>
);

export const SplitAmountArticle = () => (
  <ArticleLayout
    title="Разделить сумму на несколько человек: сколько скинуться каждому"
    description="Онлайн-калькулятор делит покупки между людьми: добавьте позиции с суммами, выберите кто платил и кто участвует — получите итоговые переводы."
    url="/razdelit-summu-na-chelovek"
    heading="Разделить сумму на человек: посчитать, сколько скинуться каждому"
    lead="Идеален для подарков, посиделок, совместных поездок: считает доли и сокращает переводы до минимума."
    relatedLinks={[
      { to: "/kto-komu-skolko-dolzhen", text: "Кто кому сколько должен" },
      {
        to: "/posle-vecherinki-kto-skolko-skinulsya",
        text: "После вечеринки",
      },
    ]}
  >
    <Header as="h2">Онлайн-калькулятор дележа суммы</Header>
    <p>
      Нужно посчитать "по сколько скидываемся"? Добавьте покупки с суммами, выберите
      кто оплатил и кто участвует в расходе — сервис сам рассчитает доли и
      переводы.
    </p>

    <Image
      src="/ss-example.png"
      alt="Пример расчета: таблица покупок и итоговые переводы"
      fluid
      rounded
      style={{ margin: "20px 0" }}
    />

    <Header as="h2">Как посчитать за минуту</Header>
    <List ordered>
      <List.Item>Создайте проект и назовите его (например, "Отметили новый год").</List.Item>
      <List.Item>Добавьте всех участников — просто введите имена</List.Item>
      <List.Item>
        Введите сумму покупки и кто заплатил.
      </List.Item>
      <List.Item>
        Если нужно, укажите пропорции: по умолчанию поровну или вручную задайте пропорции кнопками
        «+»/«-» (например 2:1:1).
      </List.Item>
    </List>

    <Header as="h2">Меньше переводов — проще договориться</Header>
    <p>
      После расчета алгоритм минимизирует количество переводов между участниками,
      чтобы каждому нужно было сделать один-два платежа. Это экономит время и
      убирает лишние движения денег туда-сюда.
    </p>

    <Segment secondary>
      <Header as="h4">Пример дележа суммы</Header>
      <p>
        Букет стоит 4200 ₽, участвуют 6 человек. Оля и Даня готовы взять на себя
        двойную долю, остальные — обычную. Добавляем строку «Букет 4200», ставим
        Даню человеком, который оплатил, выбираем всех участников и задаем пропорции 2:2:1:1:1:1.
        После расчета видно, кто кому переводит и на какую сумму.
      </p>
    </Segment>
  </ArticleLayout>
);

export const AfterPartyArticle = () => (
  <ArticleLayout
    title="Калькулятор: кто сколько скинулся после вечеринки"
    description="Подсчитайте, кто сколько скидывать после вечеринки или встречи: отметьте покупки и получайте минимальный список переводов без споров."
    url="/posle-vecherinki-kto-skolko-skinulsya"
    heading="После вечеринки: кто сколько скинулся"
    lead="Сайт подсчета денег после вечеринки показывает честные расчеты за минуту и сокращает количество переводов до минимума."
    relatedLinks={[
      { to: "/kto-komu-skolko-dolzhen", text: "Главный калькулятор переводов" },
      {
        to: "/razdelit-summu-na-chelovek",
        text: "Разделить сумму на человек",
      },
    ]}
  >
    <Header as="h2">Почему это важно</Header>
    <p>
      После вечеринки, дня рождения или выезда на природу всегда остаются чеки,
      переводы в разное время и люди, которые «скидывались позже». Калькулятор
      «СколькоСкинуть» собирает все траты и показывает, кому сколько переводить,
      чтобы никто не переплатил.
    </p>

    <Header as="h2">Как работает калькулятор сбрасывания денег</Header>
    <List ordered>
      <List.Item>Запишите все траты: продукты, доставка, такси, аренда.</List.Item>
      <List.Item>Укажите, кто оплатил каждую покупку и сколько она стоила.</List.Item>
      <List.Item>
        При необходимости разделите расходы по долям: кто ел мясо, кто только
        напитки.
      </List.Item>
      <List.Item>
        Нажмите «Рассчитать» — появится список «калькулятор кому сколько
        скидывать на вечеринку»: суммы и получатели переводов.
      </List.Item>
    </List>

    <Image
      src="/ss-example.png"
      alt="Пример расчета: таблица покупок и итоговые переводы"
      fluid
      rounded
      style={{ margin: "20px 0" }}
    />

    <Header as="h2">Меньше переводов — меньше хлопот</Header>
    <p>
      Алгоритм оптимизирует расчеты и сводит переводы к минимальному количеству.
      Вместо цепочки «я перевел Васе, Вася Маше» сразу видно пару платежей, которые
      закрывают все долги.
    </p>

    <Grid stackable columns={2}>
      <Grid.Column>
        <Header as="h3">Частые запросы, которые закрываем</Header>
        <List bulleted>
          <List.Item>«Сайт подсчета денег после вечеринки»</List.Item>
          <List.Item>«Калькулятор сбрасывания денег в компании»</List.Item>
          <List.Item>«Кому сколько скидывать на вечеринку»</List.Item>
          <List.Item>«Разобраться, по сколько нужно сброситься, чтобы быть квитами»</List.Item>
        </List>
      </Grid.Column>
      <Grid.Column>
        <Segment secondary>
          <Header as="h4">Совет</Header>
          <p>
            Делитесь ссылкой на расчет сразу после ввода чеков — участники
            увидят итог и смогут перевести деньги без напоминаний. Данные
            сохраняются в проекте, так что вы можете вернуться и добавить новую
            покупку в любой момент.
          </p>
        </Segment>
      </Grid.Column>
    </Grid>

    <Header as="h2">Начните прямо сейчас</Header>
    <p>
      Даже если траты делались в разное время разными людьми, вы получите очень короткий список переводов.
      Добавляйте оплаченные товары или расходы, и закрывайте вопрос «кто кому
      сколько должен» без лишних переписок и таблиц в экселе.
    </p>
  </ArticleLayout>
);
